module.exports = __webpack_public_path__ + "static/media/Stickermule.6aca98de.svg";